module.exports = __webpack_public_path__ + "img/blue_globe.20cb1869.png";